module.exports = __webpack_public_path__ + "static/img/rank_206.71a5bf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_206.png
// module id = ygTF
// module chunks = 1